export enum BalanceReportType {
  WITH_BALANCE = 0,
  WITH_POSITIVE_CASH = 1,
  WITHOUT_CASH = 2,
}

export const reportTypes = [
  { label: 'Todos', value: null },
  { label: 'Con saldo', value: BalanceReportType.WITH_BALANCE },
  { label: 'Filtrado con efectivo', value: BalanceReportType.WITH_POSITIVE_CASH },
  { label: 'Filtrado sin efectivo', value: BalanceReportType.WITHOUT_CASH },
]
